import qs from 'qs';
import * as React from 'react';

import { requestPost, requestPut, } from '../../../../../modules/request/index';
import useSnackbarMonitor from '../../../../Shared/hooks/useSnackbarMonitor';
import { ADMIN, Snackbar, Spinner, defaultSnackbarTimeout, } from '../../../../Shared/index';
import AssignActivityPackBanner from '../assignActivityPackBanner';

const emailVerificationSrc = `${window.postbuildEnv.CDN_URL}/images/onboarding/email_verification.svg`

const VerifyEmail = ({ user, location, }) => {
  const token = qs.parse(location.search.replace('?', '')).token
  const redirect = qs.parse(location.search.replace('?', '')).redirect
  const emailRedirectUrl = qs.parse(location.search.replace('?', '')).email_redirect_url

  const [showSnackbar, setShowSnackbar] = React.useState(false)
  const [snackbarText, setSnackbarText] = React.useState('')
  const [loading, setLoading] = React.useState(!!token)

  useSnackbarMonitor(showSnackbar, setShowSnackbar, defaultSnackbarTimeout)

  React.useEffect(() => {
    if (token) {
      verifyToken()
    }
  }, [])

  function redirectToLogin() {
    requestPost(
      '/session/set_post_auth_redirect',
      { post_auth_redirect: window.location.href },
      () => window.location.href = '/session/new'
    );
  }

  function resendVerification() {
    requestPut(`${window.postbuildEnv.DEFAULT_URL}/verify_emails/resend_verification_email`, { email_redirect_url: emailRedirectUrl, }, () => {
      setSnackbarText(`We sent another verification email to ${user.email}`)
      setShowSnackbar(true)
    })
  }

  function verifyToken() {
    requestPut(`${window.postbuildEnv.DEFAULT_URL}/verify_emails/verify_by_token`, { token, },
      () => {
        if (redirect && isValidRedirect(redirect)) {
          window.location.href = redirect
        } else if (user.role === ADMIN) {
          window.location.href = '/sign-up/select-sub-role'
        } else {
          window.location.href = '/profile'
        }
      },
      (body) => {
        if (user) {
          setLoading(false)
          setSnackbarText(body.error)
          setShowSnackbar(true)
        } else {
          redirectToLogin()
        }
      }
    )
  }

  if (loading) {
    return (
      <Spinner />
    )
  }

  return (
    <div>
      <AssignActivityPackBanner />
      <Snackbar text={snackbarText} visible={showSnackbar} />
      <div className="container account-form add-admin-info email-verification">
        <img alt="" src={emailVerificationSrc} />
        <h1>Thanks {user.name.split(' ')[0]}, you&#39;re almost done!</h1>
        <p className="sub-header">We sent an email to {user.email}.<br />Please follow the link in the email to complete verification.</p>
        <p className="body">Didn’t receive an email? <button className="interactive-wrapper" onClick={resendVerification} type="button">Resend verification</button></p>
        <p className="body">Need help? <a href="mailto:hello@quill.org?subject=Help with email verification">Contact support</a></p>
      </div>
    </div>
  )
}

function isValidRedirect(url) {
  const allowedDomains = [window.location.origin];
  try {
    const parsedUrl = new URL(url, window.location.origin);
    return allowedDomains.includes(parsedUrl.origin);
  } catch (e) {
    return false;
  }
}

export default VerifyEmail
